import { render, staticRenderFns } from "./AccountTerminologyEdit.vue?vue&type=template&id=01ad9f5a"
import script from "./AccountTerminologyEdit.vue?vue&type=script&lang=js"
export * from "./AccountTerminologyEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports